export const DEFAULT_LANGUAGE = 'DE'
export const FALLBACK_LANGUAGE = 'EN'
export const SUPPORTED_LANGUAGES = ['DE', 'EN']
